module.exports = __webpack_public_path__ + "img/nfse.48f0d242.png";